export default "__VITE_PUBLIC_ASSET__30bf6199__"